var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnAuthorizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 112,
    viewBox: "0 0 89 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2322 20.5918C88.2657 92.0725 95.9874 75.8435 44.3274 111.772C30.8486 102.404 21.424 96.5815 14.8394 91.82L88.2322 20.5918Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0079 0.000798377L83.37 11.3809L10.0212 82.5641C-2.23053 71.6707 1.13922 62.445 1.13922 15.269L23.1026 0H67.0073L67.0079 0.000798377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnAuthorizeIcon);
export default __webpack_public_path__ + "static/media/unAuthorizeIcon.529921a3bf464d022846d609d54704f3.svg";
export { ForwardRef as ReactComponent };